var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.9@core-js/library/modules/_html.js
// module id = ./node_modules/_core-js@2.6.9@core-js/library/modules/_html.js
// module chunks = 6